import { FOOD_ROOTS, TIKTOK_COUNTRIES } from '@/config/constants';

export const exportEntity = ({ name }) => name || 'trend';

export const hasFlavorsTab = ({ hierarchyHint }) =>
    FOOD_ROOTS.includes(hierarchyHint?.cat1);

/** A TikTok market shows the trend series in place of Google's prediction. */
export const isTikTokMarket = ({ country }) =>
    !!(country && TIKTOK_COUNTRIES.includes(country.text_id));
